<template>
    <div>
        <div class="content-widget">
            <div
                class="content-widget"
                :class="[standalone ? 'alternative-standalone' : 'map']"
                ref="mapHolder"
                @click="antiScroll()"
            />
            <ScrollButton
                v-if="isWheelLocked"
                :toggleModeWheel="toggleModeWheel"
                :options="data"
            />
            <ThreeDController
                v-if="data.gui && data.gui.type === 'map'"
                :data="data"
                :widget="widget"
                :widgetType="'map'"
                :targetElement="targetElement"
            />
        </div>
        <PopupInformation
            :data="popup"
            :update="updateWidget"
            :target="targetElement"
            :popupType="'hotspot'"
        />
    </div>
</template>


<script>
    import _ from 'lodash';
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapActions, mapGetters } from 'vuex';

    import PopupInformation from '@/components/plotInformation/PopupInformation';
    import ScrollButton from "@/components/ScrollButton";
    import ThreeDController from "@/components/threeDController/ThreeDController";

    export default {
        name: 'Map',
        components: {
            ThreeDController,
            PopupInformation,
            ScrollButton
        },
        props: [
            'data',
            'link',
            'active',
            'standalone'
        ],
        data () {
            return {
                targetElement: null,
                widget: null,
                popup: {
                    x: 0,
                    y: 0,
                    visible: false
                },
                distanceInfo: null,
                toggleModeWheel: false,
                search(node) {
                    this.searchInput(node);
                },
                isFavoriteActivated: false
            };
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'language',
                'protocol'
            ]),
            isWheelLocked() {
                return window.self !== window.top;
            },
            apiUrl() {
                return this.protocol + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.targetElement = this.$refs.mapHolder;
            this.search = this.search.bind(this);
            this.travelMode = this.travelMode.bind(this);
            this.render();

            EventBus.$on('map_SetActive', item => {
                this.widget.setTravelMode(item.id);
            });
        },
        methods: {
            ...mapActions([
                'setIsLoading'
            ]),
            updateCallback(link) {
                this.updateWidget(link);
            },
            callbacks() {
                let vm = this;
                return {
                    callbacks: {
                        clickCallback(hotspot, x, y) {
                            if (vm.popup.visible === true)
                                vm.closePopup();
                            else
                                vm.popup = Object.assign(hotspot, { x, y });
                        },
                        overCallback(hotspot, x, y) {
                            vm.popup = Object.assign(hotspot, { x, y });
                        },
                        outCallback() {
                            vm.popup = { 'x': 0, 'y': 0 };
                        },
                        distanceCallback(distance, duration) {
                            var distance = distance;
                            var duration = duration;
                            vm.distanceInfo = duration + ' (' + distance + ')';
                        },
                        widgetReadyCallback(widget){
                            EventBus.$emit('widgetReady',widget);
                            vm.setIsLoading(false);
                        }
                    }
                };
            },
            closePopup() {
                this.popup = {
                    marginLeft: 0,
                    marginRight: 0,
                    x: 0,
                    y: 0,
                    positionClass: ''
                };
            },
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/map-view' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        payload.type = 'map';
                        payload.gui.type = 'map';
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        payload = Object.assign(payload, this.callbacks(), { search: this.search, travelMode: this.travelMode, refreshHotspots: this.refreshHotspots });
                        this.widget = new Habiteo.MapWidget(this.$refs.mapHolder, payload);
                        EventBus.$emit('trackWidget', payload.tracking);
                        if (this.standalone) {
                            EventBus.$emit('setSidebarData', payload);
                            EventBus.$emit('updateLoadedWidgets', { id: 'map-view', link: urlLink, active: true });
                        } else 
                            EventBus.$emit('updateSidebar', payload, false);
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            },
            updateWidget(link) {
                this.widget.setTravelMode(link.id);
            },
            travelMode(value) {
                this.widget.setTravelMode(value);
            },
            searchInput(node) {
                this.widget.setItinerarySearch(node);
            },
            refreshHotspots(category, state) {
                const hotspots = this.data.hotspots;
                category.references.forEach(reference => {
                    hotspots.filter(hotspot => hotspot.id == reference).forEach(hotspot => hotspot.visible = state);
                });
                this.widget.refresh(hotspots);
            },
            antiScroll(){
                this.widget.unlockMouseWheel();
                this.toggleModeWheel = !this.toggleModeWheel;
            }
        },
        watch: {
            active(val) {
                if (val)
                    this.render();
            },
            distanceInfo(val) {
                let localData = Object.assign(this.data, { info: val });
                EventBus.$emit('updateSidebar', localData, false);
            }
        }
	};
</script>



// WEBPACK FOOTER //
// src/views/MapWidget.vue